// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-filter {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

/* Selected filter chips */
.tag-filter__selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
}

.tag-filter__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-semibold);
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
  line-height: 1.4;
  border: 1px solid var(--color-fire-600);
}

.tag-filter__chip-remove {
  background: none;
  border: none;
  color: var(--color-parchment-100);
  cursor: pointer;
  font-size: 14px;
  padding: 0 2px;
  line-height: 1;
  opacity: 0.8;
}

.tag-filter__chip-remove:hover {
  opacity: 1;
}

.tag-filter__clear-all {
  background: none;
  border: none;
  padding: 4px 8px;
  font-family: var(--font-body);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
  color: var(--color-parchment-300);
  cursor: pointer;
  transition: color var(--transition-fast);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.tag-filter__clear-all:hover {
  color: var(--color-fire-400);
}

/* Input field */
.tag-filter__field-wrap {
  position: relative;
}

.tag-filter__field {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-lg);
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  outline: none;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  box-sizing: border-box;
}

.tag-filter__field::placeholder {
  color: var(--color-text-tertiary);
}

.tag-filter__field:focus {
  border-color: var(--color-fire-500);
  box-shadow: 0 0 0 3px rgba(216, 90, 31, 0.15);
}

/* Suggestions dropdown */
.tag-filter__suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-600);
  border-top: none;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  box-shadow: var(--shadow-md);
  z-index: var(--z-dropdown);
  max-height: 220px;
  overflow-y: auto;
}

.tag-filter__suggestion {
  display: block;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: none;
  background: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  color: var(--color-text-primary);
  text-align: left;
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.tag-filter__suggestion:hover {
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
}

/* Collapsible all-tags section */
.tag-filter__all-tags {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.tag-filter__toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  background: none;
  border: none;
  padding: var(--space-1) 0;
  font-family: var(--font-heading);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-400);
  cursor: pointer;
  user-select: none;
  transition: color var(--transition-fast);
}

.tag-filter__toggle-btn:hover {
  color: var(--color-fire-500);
}

.tag-filter__toggle-icon {
  display: inline-block;
  transition: transform var(--transition-fast);
  font-size: 12px;
}

.tag-filter__toggle-icon--open {
  transform: rotate(90deg);
}

.tag-filter__all-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  padding: var(--space-3);
  background: var(--color-wood-800);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
}

.tag-filter__pickable-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  background: var(--color-wood-600);
  color: var(--color-parchment-100);
  border: 1px solid var(--color-wood-700);
  cursor: pointer;
  transition: all var(--transition-fast);
  line-height: 1.4;
  font-weight: var(--font-weight-medium);
}

.tag-filter__pickable-tag:hover {
  background: var(--color-fire-500);
  border-color: var(--color-fire-600);
  color: var(--color-parchment-100);
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameTagFilter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,kFAAkF;EAClF,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,oDAAoD;EACpD,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC","sourcesContent":[".tag-filter {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n/* Selected filter chips */\n.tag-filter__selected {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.tag-filter__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-semibold);\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n  line-height: 1.4;\n  border: 1px solid var(--color-fire-600);\n}\n\n.tag-filter__chip-remove {\n  background: none;\n  border: none;\n  color: var(--color-parchment-100);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 2px;\n  line-height: 1;\n  opacity: 0.8;\n}\n\n.tag-filter__chip-remove:hover {\n  opacity: 1;\n}\n\n.tag-filter__clear-all {\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  font-family: var(--font-body);\n  font-size: var(--font-size-caption);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-parchment-300);\n  cursor: pointer;\n  transition: color var(--transition-fast);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.tag-filter__clear-all:hover {\n  color: var(--color-fire-400);\n}\n\n/* Input field */\n.tag-filter__field-wrap {\n  position: relative;\n}\n\n.tag-filter__field {\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-lg);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  outline: none;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.tag-filter__field::placeholder {\n  color: var(--color-text-tertiary);\n}\n\n.tag-filter__field:focus {\n  border-color: var(--color-fire-500);\n  box-shadow: 0 0 0 3px rgba(216, 90, 31, 0.15);\n}\n\n/* Suggestions dropdown */\n.tag-filter__suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-600);\n  border-top: none;\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  z-index: var(--z-dropdown);\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.tag-filter__suggestion {\n  display: block;\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  border: none;\n  background: none;\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  color: var(--color-text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.tag-filter__suggestion:hover {\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n}\n\n/* Collapsible all-tags section */\n.tag-filter__all-tags {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.tag-filter__toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  background: none;\n  border: none;\n  padding: var(--space-1) 0;\n  font-family: var(--font-heading);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-400);\n  cursor: pointer;\n  user-select: none;\n  transition: color var(--transition-fast);\n}\n\n.tag-filter__toggle-btn:hover {\n  color: var(--color-fire-500);\n}\n\n.tag-filter__toggle-icon {\n  display: inline-block;\n  transition: transform var(--transition-fast);\n  font-size: 12px;\n}\n\n.tag-filter__toggle-icon--open {\n  transform: rotate(90deg);\n}\n\n.tag-filter__all-tags-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n  padding: var(--space-3);\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n}\n\n.tag-filter__pickable-tag {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  background: var(--color-wood-600);\n  color: var(--color-parchment-100);\n  border: 1px solid var(--color-wood-700);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  line-height: 1.4;\n  font-weight: var(--font-weight-medium);\n}\n\n.tag-filter__pickable-tag:hover {\n  background: var(--color-fire-500);\n  border-color: var(--color-fire-600);\n  color: var(--color-parchment-100);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
